import React from 'react';
import clsx from 'clsx';
import { AEyebrow, AEyebrowVariant } from '../../atoms/AEyebrow/index';
import { AHeader } from '../../atoms/AHeader/index';
import { AHeaderSize, AHeaderTag } from '../../atoms/AHeader/AHeader.types';
import { AAccentLine } from '../../atoms/AAccentLine/index';
import { AAccentLineSize, AAccentLineAlignment } from '../../atoms/AAccentLine/AAccentLine.types';
import { ASubheader } from '../../atoms/ASubheader/index';
import { ASubheaderSize, ASubheaderTag } from '../../atoms/ASubheader/ASubheader.types';
import { ABody } from '../../atoms/ABody/index';
import { ABodySize, ABodyColor } from '../../atoms/ABody/ABody.types';
import * as Styled from './MTextBlockFull.styles';
import type { MTextBlockFullProps } from './MTextBlockFull.types';
import { MTextBlockFullAlignment } from './MTextBlockFull.types';

const COMPONENT_NAME = 'm-web-ui-kit-MTextBlockFull';
const TEST_ID = 'web-ui-kit-MTextBlockFull';

export const MTextBlockFull: React.FC<MTextBlockFullProps> = ({
  alignment = MTextBlockFullAlignment.Left,
  aEyebrow,
  aHeader,
  aAccentLine,
  aSubheader,
  aBody,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={clsx('m-text-block-full', className, alignment)}
      $alignment={alignment}
      {...rest}
    >
      {aEyebrow?.eyebrowText && (
        <Styled.EyebrowWrapper>
          <AEyebrow variant={AEyebrowVariant.Primary} {...aEyebrow} />
        </Styled.EyebrowWrapper>
      )}

      {aHeader?.text && (
        <Styled.HeaderWrapper>
          <AHeader size={AHeaderSize.TitleM} element={AHeaderTag.h2} {...aHeader} />
        </Styled.HeaderWrapper>
      )}

      {aAccentLine && (
        <Styled.AccentLineWrapper>
          <AAccentLine
            size={aAccentLine.size || AAccentLineSize.OnePx}
            alignment={
              alignment === MTextBlockFullAlignment.Centered ? AAccentLineAlignment.Centered : AAccentLineAlignment.Left
            }
            {...aAccentLine}
          />
        </Styled.AccentLineWrapper>
      )}

      {aSubheader?.text && (
        <Styled.SubheaderWrapper>
          <ASubheader size={ASubheaderSize.XL} element={ASubheaderTag.h3} {...aSubheader} />
        </Styled.SubheaderWrapper>
      )}

      {aBody?.bodyText && (
        <Styled.BodyWrapper>
          <ABody size={ABodySize.M} color={ABodyColor.Default} {...aBody} />
        </Styled.BodyWrapper>
      )}
    </Styled.Wrapper>
  );
};

export { MTextBlockFullAlignment, TEST_ID as M_TEXT_BLOCK_FULL_TEST_ID };
export type { MTextBlockFullProps } from './MTextBlockFull.types';
